__webpack_require__.p = "/static/merch/product-page-v2-vp-eu-de-ch.prod/";